import React, { useState, useContext, useEffect } from "react";
import "./IndividualProductPage.css";
import { Context } from "../../Context/Context";
const IndividualProductPage = ({ product }) => {
  const [size, setSize] = useState("Small");
  const [mainImg, setMainImg] = useState(null);
  const { addToCart } = useContext(Context);

  useEffect(() => {
    if (product) {
      setMainImg(product.image);
    }
  }, [product]);

  if (!product) {
    return <div>no product found</div>;
  }

  const price = product.price[size];

  return (
    <div className="individualproductpage">
      <div className="individualproductpage-left">
        <div className="individualproductpage-main-img">
          <img src={mainImg || product.image} alt="" />
        </div>
        <div className="individualproductpage-img-list">
          {(product.images || [product.image]).map((imgSrc, index) => (
            <img key={index} src={imgSrc} alt="" onClick={() => setMainImg(imgSrc)} />
          ))}
        </div>
      </div>
      <div className="individualproductpage-right">
        <h1>{product.name}</h1>
        <div className="individualproductpage-right-price">
          <h2>{price}</h2>
        </div>
        <div className="individualproductpage-right-sizes">
          <button
            onClick={() => setSize("Small")}
            className={`size-btn ${size === "Small" ? "active" : ""} ${["unavailable", "sold out"].includes(product.price["Small"]) ? "unavailable" : ""}`.trim()}
          >
            Small
          </button>
          <button
            onClick={() => setSize("Medium")}
            className={`size-btn ${size === "Medium" ? "active" : ""} ${["unavailable", "sold out"].includes(product.price["Medium"]) ? "unavailable" : ""}`.trim()}
          >
            Medium
          </button>
          <button
            onClick={() => setSize("Large")}
            className={`size-btn ${size === "Large" ? "active" : ""} ${["unavailable", "sold out"].includes(product.price["Large"]) ? "unavailable" : ""}`.trim()}
          >
            Large
          </button>
        </div>
        {product.description && (
          <div className="individualproductpage-right-description">
            <p>{product.description}</p>
          </div>
        )}
        <div className="individualproductpage-right-cart">
          <button 
            onClick={() => {
              if (!["unavailable", "sold out"].includes(product.price[size])) {
                addToCart(product.id, size);
              }
            }}
            disabled={["unavailable", "sold out"].includes(product.price[size])}
            className={`cart-btn ${["unavailable", "sold out"].includes(product.price[size]) ? "unavailable-cart" : ""}`.trim()}
          >
            Add to Cart
          </button>
        </div>
      </div>
    </div>
  );
};

export default IndividualProductPage;
